module.exports = __webpack_public_path__ + "static/mobile-screen-18e53f37708f2786c52e1d1cca32f7c5.jpg";